import { PARAM_RETUR_URL, PARAM_RETUR_URL_TEKST, tjenestePath } from 'src/types/url';
import { getSkjemaNameFromUrl } from 'src/util';

import { getAppUrl } from '@helsenorge/framework-utils/url';
import { HNeventShowAppInvitation } from '@helsenorge/framework-utils/web-component/events';

const getWindowOrigin = (): string => window.location.origin || new URL(window.location.href).origin;

export const removeReturnUrlParams = (url: string): string => {
  const cleanedUrl = new URL(url, getWindowOrigin());

  for (const parameterName of Array.from(cleanedUrl.searchParams.keys())) {
    const lowerCaseParameterName = parameterName.toLowerCase();
    if (lowerCaseParameterName === PARAM_RETUR_URL || lowerCaseParameterName === PARAM_RETUR_URL_TEKST) {
      cleanedUrl.searchParams.delete(parameterName);
    }
  }

  const source = cleanedUrl.searchParams.get('Source');
  if (source) {
    cleanedUrl.searchParams.set('Source', removeReturnUrlParams(source));
  }

  return cleanedUrl.pathname + cleanedUrl.search + cleanedUrl.hash;
};

const getAbsoluteSourceUrl = (url: string): string => {
  const parsedUrl = new URL(url, getWindowOrigin());
  const sourceUrl = parsedUrl.pathname === '/auth/signin' ? parsedUrl.searchParams.get('Source') || window.location.href : url;
  const cleanedUrl = new URL(removeReturnUrlParams(sourceUrl), getWindowOrigin());
  return cleanedUrl.href;
};

export const getLoginUrl = (sourceUrl: string): string => `/auth/signin?Source=${encodeURIComponent(getAbsoluteSourceUrl(sourceUrl))}`;

export const useLogin = (): { login: (ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>) => void } => {
  const appUrl = getAppUrl();
  const handleLogin = (): void => {
    const cleanedUrl = new URL(removeReturnUrlParams(window.location.href), getWindowOrigin());
    window.history.replaceState(window.history.state, '', getLoginUrl(cleanedUrl.href));
    window.location.reload();
  };

  const login = (ref?: React.MutableRefObject<HTMLButtonElement | HTMLAnchorElement | null>): void => {
    if (appUrl) {
      HNeventShowAppInvitation(
        () => {
          const tekniskNavn = getSkjemaNameFromUrl();
          const fullAppUrl = appUrl + tjenestePath + `/${tekniskNavn}`;
          window.location.href = fullAppUrl;
        },
        () => {
          handleLogin();
        },
        () => {
          ref?.current?.focus();
        }
      );
    } else {
      handleLogin();
    }
  };
  return { login };
};
